import { merge } from 'lodash';
import React, { useCallback, useState } from 'react';
import { Button, ButtonStyles } from '@silverfort/sf-components';
import { Schema } from 'jsonschema';

import MergeJsonPopup from './MergeJsonPopup';
import JsonField from '../Controls/JsonField/JsonField';

interface AdminConsoleConfigField {
    id: string;
    value: string;
    error?: string;
    validators: {
        jsonSchema: Schema;
    };
}

interface AdminConsoleConfigProps {
    adminConsoleConfig: AdminConsoleConfigField;
    onConfigChanged: (id: string, value: string) => void;
}

const AdminConsoleConfig: React.FC<AdminConsoleConfigProps> = ({ adminConsoleConfig, onConfigChanged }) => {
    const [mergeAdvancedConfigModalOpen, setMergeAdvancedConfigModalOpen] = useState(false);

    const onMerge = useCallback(
        (mergeJson) => {
            try {
                const parsedMergeConfig = JSON.parse(mergeJson);
                const parsedAdminConsoleConfig = JSON.parse(adminConsoleConfig.value);
                const mergedConfig = merge(parsedAdminConsoleConfig, parsedMergeConfig);
                onConfigChanged(adminConsoleConfig.id, JSON.stringify(mergedConfig, null, 4));
            } catch (error) {
                console.error('Error while merging configurations:', error);
            }
        },
        [adminConsoleConfig, onConfigChanged]
    );

    if (!adminConsoleConfig) {
        return null;
    }

    return (
        <>
            <JsonField field={adminConsoleConfig} changed={onConfigChanged} style={{ marginBottom: 4 }} />
            <div className="flex w-[700px] justify-end mb-4">
                <Button
                    text="Merge"
                    buttonStyle={ButtonStyles.Primary}
                    disabled={!adminConsoleConfig.value || !!adminConsoleConfig.error}
                    onClick={() => setMergeAdvancedConfigModalOpen(true)}
                />
            </div>
            <MergeJsonPopup
                open={mergeAdvancedConfigModalOpen}
                onClose={() => setMergeAdvancedConfigModalOpen(false)}
                jsonSchema={adminConsoleConfig.validators.jsonSchema}
                onMerge={onMerge}
            />
        </>
    );
};

export default AdminConsoleConfig;
